import React from 'react'
import styles from './Profile.module.scss'
import { UserInfo } from 'components/UserInfo/UserInfo'
import { Button } from 'components/Button/Button'
import { CopyLink } from 'components/CopyLink/CopyLink'
import { MOCK_USER_DATA } from 'components/FormDeposit/const'

type Props = {
    isPublic?: boolean,
    onCustomize?: () => void,
}

export function Profile(props: Props) {
    const [data, setData] = React.useState(MOCK_USER_DATA)

    if (!props.isPublic) {
        return (
            <div className={styles['wrapper']}>
                <div>
                    <div className={styles['title']}>
                        Drizzle page
                    </div>
                    <UserInfo data={data} isPublic={props.isPublic} />
                </div>
                <div className={styles['button-anonymous']}>
                    <Button size='m' type='primary'>
                        Public your page
                    </Button>
                    <span className={styles['help-anonymous']}>Public your Drizzle page to share with your fans on social media</span>
                </div>
            </div>
        )
    }

    return (
        <div className={styles['wrapper']}>
            <div>
                <div className={styles['content']}>
                    <UserInfo data={data} isPublic={props.isPublic} />
                </div>
            </div>
            <div className={styles['button']}>
                <Button
                    size='s'
                    type='dark'
                    iconRight
                    iconName='forward'
                    stretch={false}
                    onClick={props.onCustomize}
                >
                    Customize page
                </Button>
                <CopyLink link='drizzle.com' />
            </div>
        </div>
    );
}

